export default __webpack_public_path__ + "static/media/sns-facebook.186ccfab.svg";